import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Switch, Typography, Divider } from '@mui/material';

const CallOptionsDialog = ({ open, onClose, onConfirm }) => {
  const [option, setOption] = useState('default');
  const [customInstructions, setCustomInstructions] = useState('');
  const [requestCallback, setRequestCallback] = useState(true);

  const handleConfirm = () => {
    let instructions = option === 'default' ? 'get live agent' : customInstructions;
    // Append callback preference to instructions
    if (requestCallback) {
      instructions += ' [CALLBACK_PREFERRED]';
    } else {
      instructions += ' [HOLD_PREFERRED]';
    }
    onConfirm(instructions);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Call Options</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset" style={{ marginBottom: '16px' }}>
          <FormLabel component="legend">Instructions</FormLabel>
          <RadioGroup value={option} onChange={(e) => setOption(e.target.value)}>
            <FormControlLabel value="default" control={<Radio />} label="Use default: 'get live agent'" />
            <FormControlLabel value="custom" control={<Radio />} label="Custom instructions" />
          </RadioGroup>
        </FormControl>
        {option === 'custom' && (
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={customInstructions}
            onChange={(e) => setCustomInstructions(e.target.value)}
            placeholder="Enter your custom instructions here..."
            margin="normal"
          />
        )}
        <Divider style={{ margin: '16px 0' }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2">
            Request callback if long hold time
          </Typography>
          <Switch
            checked={requestCallback}
            onChange={(e) => setRequestCallback(e.target.checked)}
            color="primary"
          />
        </div>
        <Typography variant="caption" color="textSecondary">
          {requestCallback
            ? "Maia will request a callback instead of waiting on hold"
            : "Maia will stay on hold until an agent is available"}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallOptionsDialog;